module.exports = __webpack_public_path__ + "static/apple-app-store-badge-4375688d569528c298994bf70920e0ad.png";